import React, { FC } from 'react';
import { InputError } from '../InputError';
import { Label } from '../Label';

export type InputGroupProps = {
  label?: string;
  optional?: boolean;
  errorMessage?: string;
  children?: React.ReactNode;
};

export const InputGroup: FC<InputGroupProps> = ({
  label,
  optional,
  errorMessage,
  children,
}: InputGroupProps) => {
  return (
    <>
      {label ? <Label content={label} optionalLabel={optional} /> : null}
      {children}
      {errorMessage ? <InputError text={errorMessage} /> : null}
    </>
  );
};
